import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';

export default [
  {
    title: 'Inventory',
    channel: 'amazon-seller',
    icon: { icon: 'tabler:building-warehouse' },
    // No group-level envOnly: Consolidated Inventory has shipped, and VerticalNavGroup
    // gates the group itself — a dev-only group would hide its released child on prod.
    // The remaining children stay individually dev-only.
    feature: MARKETPLACE_FEATURE.INVENTORY,
    children: [
      {
        title: 'FBA Shipments',
        action: 'read',
        subject: 'User',
        to: { name: 'inventory-fba-shipments-tab', params: { tab: 'shipments' } },
        icon: { icon: 'lucide:truck' },
        envOnly: 'development',
      },
      {
        title: 'AWD Shipments',
        action: 'read',
        subject: 'User',
        to: { name: 'inventory-awd-shipments-tab', params: { tab: 'inbound' } },
        icon: { icon: 'lucide:truck' },
        envOnly: 'development',
      },
      {
        title: 'Removal Orders',
        action: 'read',
        subject: 'User',
        to: 'inventory-removal-orders',
        icon: { icon: 'ic:outline-delete-sweep' },
        envOnly: 'development',
      },
      {
        title: 'Ledger Summary',
        action: 'read',
        subject: 'User',
        to: 'inventory-ledger-summary',
        icon: { icon: 'ic:outline-list-alt' },
        envOnly: 'development',
      },
      {
        title: 'Ledger Detail',
        action: 'read',
        subject: 'User',
        to: 'inventory-ledger-detail',
        icon: { icon: 'ic:outline-receipt' },
        envOnly: 'development',
      },
      {
        title: 'FBA Inventory',
        action: 'read',
        subject: 'User',
        to: 'inventory-fba-inventory',
        icon: { icon: 'ic:outline-inventory-2' },
        envOnly: 'development',
      },
      {
        title: 'Consolidated Inventory',
        action: 'read',
        subject: 'User',
        to: 'inventory-consolidated',
        icon: { icon: 'tabler:stack-3' },
      },
      {
        title: 'FBA Planning',
        action: 'read',
        subject: 'User',
        to: 'inventory-fba-planning',
        icon: { icon: 'ic:outline-fact-check' },
        envOnly: 'development',
      },
      {
        title: 'Restock Recommendations',
        action: 'read',
        subject: 'User',
        to: 'inventory-restock-recommendations',
        icon: { icon: 'ic:outline-inventory-2' },
        envOnly: 'development',
      },
      {
        title: 'Stranded Inventory',
        action: 'read',
        subject: 'User',
        to: 'inventory-stranded',
        icon: { icon: 'ic:outline-report-problem' },
        envOnly: 'development',
      },
      {
        title: 'AWD Inventory',
        action: 'read',
        subject: 'User',
        to: 'inventory-awd-inventory',
        icon: { icon: 'ic:outline-warehouse' },
        envOnly: 'development',
      },
      {
        title: 'AFN Inventory',
        action: 'read',
        subject: 'User',
        to: 'inventory-afn-inventory',
        icon: { icon: 'ic:outline-store' },
        envOnly: 'development',
      },
    ],
  },
];
